import React, { useContext } from 'react';
import algoliaAnalytics from 'search-insights';

import { QtySelect } from 'src/components/Forms/QtySelect';
import { Button } from 'src/components/Button/Button';
import { Svg } from 'src/components/Svg/Svg';
import { QtyInput } from 'src/components/Forms/QtyInput';
import { AlgoliaContext } from 'src/components/Algolia/SearchDropdown/AlgoliaContext';

import classes from './ProductActions.scss';

export function ProductActions() {
    const { customerToken } = useContext(AlgoliaContext);

    return (
        <div className={classes.cta}>
            <div className={classes.qtyInput}>
                <QtyInput id="product">
                    <QtySelect id="product" field="qty" initialValue={1} />
                </QtyInput>
            </div>
            <div className={classes.addToCart}>
                <Button
                    data-test-id="product-add"
                    type="submit"
                    variant="primary"
                    icon="left-of-text"
                    width="full"
                    aria-label="Add to Basket"
                    aria-live="polite"
                    onClick={() => {
                        /**
                         * Algolia convertion data needed for event:
                         * index: "indexName",
                         * eventName: 'Product added to cart',
                         * userToken: 'user-1',
                         * objectIDs: [objectID],
                         * queryID: queryId
                         */
                        const queryString = (window as any).location.search;

                        if (!queryString) return;

                        const urlParams = new URLSearchParams(queryString);
                        const queryId = urlParams.get('queryId');
                        const objectID = urlParams.get('objectId');
                        const indexName = urlParams.get('indexName');

                        if (indexName && customerToken) {
                            algoliaAnalytics('convertedObjectIDsAfterSearch', {
                                index: indexName!,
                                eventName: `Product added to cart'`,
                                userToken: customerToken,
                                objectIDs: [objectID!],
                                queryID: queryId!,
                            });
                        }
                    }}
                >
                    <Svg name="basket" />
                    <span>Add to Cart</span>
                </Button>
            </div>
        </div>
    );
}
